import PageContext from "global_state/context/PageContext";
import { useContext, useEffect, useRef, useState } from "react";
import { CreditHistoryI, getUserCreditHistoryService } from "services/user_services/getUserCreditHistoryService";
import Loader from "./Loader";
import Title from "./Title";

import SCSS from 'assets/scss/CreditHistory.module.scss'
import UserContext from "global_state/context/UserContext";
import { BiChevronsDown, BiChevronsUp } from "react-icons/bi";

import AppSCSS from 'assets/scss/App.module.scss'

import content from 'languages/CreditHistory.json'

function CreditHistory() {
    const {page} = useContext(PageContext)
    const {user} = useContext(UserContext)
    let lang = page.settings.language

    const [loading, setLoading] = useState(false)
    const [credit_history_res, setCreditHistoryRes] = useState<any>([])
    const [credit_history_loaded, setCreditHistoryLoaded] = useState(false)


    let page_number = 0
    let page_size = 10
    
    const lastRef = useRef<any>(null)
    
    const getCreditHistory = async(scrollX, scrollY) => {
        if (loading) {
            return 
        }
        setLoading(true)
        
        let credit_history_fetched = await getUserCreditHistoryService(user.client_id, page_number, page_size)
        
        if (typeof credit_history_fetched === 'string') {
            // TODO: Set Error message
            setLoading(false)
            return 
        }

        if (credit_history_fetched.length === 0) {
            setCreditHistoryLoaded(true)
            setLoading(false)
            return 
        }

        credit_history_fetched.forEach(r => {
            // console.log(r);
            
            setCreditHistoryRes(data => {
                if (data.some(e => e.data == r.date)) {
                    return data
                }
                return [...data, r]
            })
            
        })


        page_number += 1
        
        // console.log(page_number);
        window.scrollTo(scrollX, scrollY)
        setTimeout(() => setLoading(false), 1500);
        
    }

    const lazyLoading = (event) => {
        if (loading) {
            return
        }
        if (lastRef.current == null) {
            return 
        }
        let lastKnownScrollPositionY = window.scrollY - 150
        let lastKnownScrollPositionX = window.scrollX
        // console.log(lastKnownScrollPositionX, lastKnownScrollPositionY);
        // console.log(lastRef.current.getBoundingClientRect().bottom, window.innerHeight);
        
        if ( lastRef.current.getBoundingClientRect().bottom <= window.innerHeight ) {
            getCreditHistory(lastKnownScrollPositionX, lastKnownScrollPositionY)
        }
        

    }

    useEffect(() => {
        if (loading) {
            return 
        }

        getCreditHistory(0,0)
        // console.log("useEffect executed (component mounted)")
        document.addEventListener("scroll", event => lazyLoading(event))
        
        return () => {
            // console.log("useEffect cleanup (component unmounted)")
            setLoading(false)
            setCreditHistoryRes([])
            setCreditHistoryLoaded(false)
            document.removeEventListener("scroll", event => lazyLoading(event));
        };

    }, [])


    const renderCreditHistory = () => {
        if (!credit_history_res) {
            return null
        }
        return credit_history_res.map((value, index) => {
            return (
                <CreditHistoryRecord key={"chr" + index} record={value}/>
            )
        })
        
    }
    const renderLazyLoading = () => {
        if (loading && !credit_history_loaded) {
            return <Loader/>
        }

        return <div ref={lastRef} className={SCSS.empty}></div>
    }

    return (
        <div className={SCSS.credit_history}>
            <Title back_arrow={true} title={content[lang].title} />
            <div className={SCSS.credit_history_wrapper}>
                {renderCreditHistory()}
            </div>
            {renderLazyLoading()}
        </div>
    )
}

export default CreditHistory;


interface CreditHistoryRecordProps {
    record: CreditHistoryI
}
function CreditHistoryRecord(props: CreditHistoryRecordProps) {
    const {page} = useContext(PageContext)
    let lang = page.settings.language

    const [open_detail, setOpenDetail] = useState(false)

    const renderDate = (date: Date) => {
        let d = new Date(date)
         let year = d.getFullYear()
         let month = d.getMonth() + 1
         let day = d.getDate()
         let hours = d.getHours()
         let minutes = d.getMinutes()
         return (
            <div>
                <div>{day}.{month}.{year}</div>
                <div>{('0' + hours).slice(-2)}:{('0' + minutes).slice(-2)}</div>
            </div>
             
         )
    }
    const renderShorDescription = (description) => {
        
        let short_description = description.detail.split('.')[0]
        if (short_description.includes("Zruseni uzavreni uctu")) {
            return (
                content[lang].credit_descriptions['canceled_payment']
            )
        }

        if (short_description.includes("Online - kredit")) {
            return content[lang].credit_descriptions['online_credit']
        }
        if (short_description.includes("Platba z kreditu")) {
            return content[lang].credit_descriptions['payment_from_credit']
        }
        return short_description
        // return (
        //     description.detail.split('.')[0]
        // )
    }
    const renderPurchasedItems = (description) => {
        if (!open_detail) {
            return 
        }

        return description.purchased_items.map((value, index) => {
            // console.log('render Purchased Items'.toUpperCase());
            
            // console.log(value);
            
            return (
                <div key={'item_' + index} className={[SCSS.item, (index == 0)? SCSS.first : ""].join(' ')}>
                    <span className={SCSS.name}>{value.name}</span>
                    <span className={SCSS.amount}>{value.amount}</span>
                    <span className={SCSS.price}>{value.total_price} Kč</span>
                </div>
            )
        }) 
    }
    const tooglePurchasedItems = (e) => {
        setOpenDetail(v => !v)
    }
    const renderPurchasedItemsHeader = (description) => {
        // BiChevronsUp
      
        if (props.record.description.purchased_items.length > 0) {
            if (open_detail) {
                return (
                    <button 
                    onClick={e => tooglePurchasedItems(e)}
                    className={[AppSCSS.button, AppSCSS.red, AppSCSS.center_icon].join(' ')}>

                        Detail
                        <BiChevronsUp className={SCSS.icon}/>
                    </button>)
            }

            return (
                <button 
                    onClick={e => tooglePurchasedItems(e)}
                    className={[AppSCSS.button, AppSCSS.red, AppSCSS.center_icon].join(' ')}>
                        Detail
                        <BiChevronsDown className={SCSS.icon}/>
                </button>)
        }
    

      
        
    }
    const hasItems = () => {
        if (props.record.description.purchased_items.length > 0) {
            return SCSS.not_empty
        }
        return null
    }

    return (
        <div className={SCSS.credit_history_record}>
            <div className={SCSS.general}>

                <div className={SCSS.date}>
                    {renderDate(props.record.date)}
                </div>
                <div className={SCSS.description}>
                    {renderShorDescription(props.record.description)}
                    {/* {props.record.description} */}
                </div>
                <div className={SCSS.amount}>
                    {props.record.amount} Kč
                </div>
            </div>
            <div className={[SCSS.purchased_items, hasItems()].join(' ')}>
                {renderPurchasedItemsHeader(props.record.description)}
                {renderPurchasedItems(props.record.description)}

            </div>
        </div>
    )
}